import { Box, Divider, PageFooter } from '@wix/design-system';
import {
  CycleUtils,
  getSearchParams,
  GtmEvents,
  useGtmLogger,
} from '@wix/package-picker-shared';
import {
  Checkout,
  useCurrentModule,
  EclipsePackagePickerSteps,
  Faq,
  NonBlockerWrapper,
  TrustBuilders,
  useInitLayoutBiEvents,
  useInitCheckoutPageBiEvents,
  useIsTrustBuildersRedesign,
  PageDisclaimer,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AllPlansIncludedFeaturesBanner } from '../../components/AllPlansIncludedFeaturesBanner';
import {
  StepSubtitle,
  CONTEXTUAL_SUBTITLE_EXPERIMENT_KEY,
} from '../../components/StepSubtitle';
import { HeaderBanner } from '../../components/HeaderBanner';
import { NavigateBack } from '../../components/NavigateBack';
import { PageTitle } from '../../components/PageTitle';

export const CheckoutPage = () => {
  const module = useCurrentModule();
  const { t } = module.internals.useTranslations();
  const changeRoute = module.internals.hooks.useChangeRoute();
  const { experiments } = module.internals.experiments.hooks.useExperiments();
  const isCheckoutWithoutFaqEnabled =
    experiments.isEnabled('checkoutWithoutFaq');
  const isCheckoutWithoutTrustBuildersEnabled = experiments.isEnabled(
    'checkoutWithoutTrustBuilders',
  );
  const isStepSubtitleEnabled = experiments.isEnabled(
    CONTEXTUAL_SUBTITLE_EXPERIMENT_KEY,
  );
  const isTrustBuildersRedesign = useIsTrustBuildersRedesign();
  useGtmLogger(GtmEvents.CHECKOUT);
  useInitCheckoutPageBiEvents();
  useInitLayoutBiEvents();

  // Sync productId & cycleId from URL query params into store
  React.useEffect(() => {
    const { productId, cycleId } = getSearchParams();
    if (productId) {
      module.SDK.PackagePickerStore.setSelectedProductId(productId);
    }
    if (cycleId) {
      module.SDK.PackagePickerStore.setSelectedCycleId(
        CycleUtils.validateCycleId(cycleId),
      );
    }
  }, []);

  const handleBack = () => {
    module.internals.bi.onBackButtonClick?.({
      fromStep: EclipsePackagePickerSteps.CHECKOUT,
    });
    changeRoute(EclipsePackagePickerSteps.SELECT_CYCLE);
  };

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      paddingBottom="SP6"
      boxSizing="border-box"
    >
      <HeaderBanner />
      <Box
        margin="0 auto"
        direction="vertical"
        width="100%"
        align="center"
        padding="0px SP6"
        boxSizing="border-box"
      >
        <Box width="100%" direction="horizontal" verticalAlign="middle">
          <NavigateBack
            onBack={handleBack}
            backButtonText={t('premium-purchase-plan.eclipse.back.cta')}
          />
          <PageTitle />
        </Box>
        <Box width="100%" marginTop="SP3">
          {isStepSubtitleEnabled ? (
            <StepSubtitle textKey="premium-purchase-plan.eclipse.checkout.subtitle" />
          ) : (
            <NonBlockerWrapper componentName="AllPlansIncludedFeaturesBanner">
              <AllPlansIncludedFeaturesBanner />
            </NonBlockerWrapper>
          )}
        </Box>
        <Box width="100%" align="center" direction="vertical">
          <Box marginTop="SP7" direction="vertical">
            <Checkout shouldOpenDoublePurchaseModal />
            <PageDisclaimer />
          </Box>
        </Box>
        {!isCheckoutWithoutTrustBuildersEnabled && (
          <Box width="100%" align="center" marginTop="SP10">
            {isTrustBuildersRedesign ? (
              <Box
                direction="vertical"
                gap="50px"
                width="100%"
                maxWidth="1280px"
                padding="0 SP2"
                boxSizing="border-box"
              >
                <Divider />
                <TrustBuilders />
              </Box>
            ) : (
              <TrustBuilders />
            )}
          </Box>
        )}
        {!isCheckoutWithoutFaqEnabled && (
          <Box
            marginTop={
              isTrustBuildersRedesign && !isCheckoutWithoutTrustBuildersEnabled
                ? '50px'
                : '78px'
            }
            width="100%"
          >
            <NonBlockerWrapper componentName="Faq">
              <Faq />
            </NonBlockerWrapper>
          </Box>
        )}
        <PageFooter />
      </Box>
    </Box>
  );
};
